import React from 'react';
import { useLocation } from 'react-router-dom';
import { TextInput } from '@razorpay/blade/components';
import { FormContainer } from 'components/Onboarding/CompanyDetails/styles';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import useReduxSelector from 'utils/useReduxSelector';
import { orgTypes } from '../constants';
import { PanNameView } from 'components/Onboarding/components/PanNameView';
import { useCompanyVerificationData } from '../hooks/useCompanyVerificationDetails';
import useFeature from 'hooks/useFeature';
import { OfficeLocationForm } from './components/OfficeLocationForm';
import { FormProvider } from 'forms';
import { OfficeLocationFormData } from 'components/OfficeLocation/CreateOfficeLocations/types';

export const UpdateOfficeLocation = () => {
  const { isEsicMultiLocationEnabled } = useFeature('esicMultiLocation');

  const { authorizedSignatory, gstin } = useCompanyVerificationData();
  const org = useReduxSelector(loggedInUserSelectors.currentOrganization);
  const orgType = org?.type;

  const {
    state: { signatoryName, signatoryPan, officeLocation },
  } = useLocation<{
    signatoryName?: string;
    signatoryPan?: string;
    officeLocation?: OfficeLocationFormData;
  }>();

  const redirectToDashboard = () => {
    window.location.href = '/dashboard';
  };

  if (!isEsicMultiLocationEnabled || !officeLocation?.id) {
    redirectToDashboard();
    return null;
  }

  const isAuthorizedSignatoryPrefilled =
    orgType === orgTypes.SOLE_PROP && !!authorizedSignatory?.pan && !!authorizedSignatory?.name;

  return (
    <form>
      <FormContainer>
        <PanNameView title="Authorised Signatory Name" value={signatoryName || ''} />
        <TextInput
          name="gstin"
          label="GSTIN"
          placeholder="Eg. 22AAAAA0000A1Z5"
          helpText="Claim GST credit on invoices by adding GST"
          value={gstin || ''}
          isRequired
          autoFocus
          isDisabled
        />
        <TextInput
          name="signatoryPan"
          label="Authorised Signatory PAN"
          placeholder="Eg. BZBIJ7819G"
          value={signatoryPan || ''}
          isRequired
          isDisabled
          helpText={
            isAuthorizedSignatoryPrefilled
              ? 'Authorized signatory PAN is same as your personal PAN for Sole-Prop business type'
              : ''
          }
        />
      </FormContainer>

      <FormProvider initialState={officeLocation || {}}>
        <OfficeLocationForm />
      </FormProvider>
    </form>
  );
};
